import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { tabPaneArr, tabData } from './conf';
import { payrollSubProjectInfo, calculate, getSubProjectCalculateState, getOnFileNotice, payrollSubProjectOnFile } from '@/api/payroll';
import ExportExcelDialog from '@/components/ExportExcelDialog';
export default {
  components: _defineProperty({}, ExportExcelDialog.name, ExportExcelDialog),
  data: function data() {
    return {
      loading: false,
      activeStep: 0,
      activeObj: {},
      tabPaneArr: tabPaneArr,
      activeData: tabData,
      isDisable: true,
      projectId: this.$route.params.id,
      clearTime: null,
      subStaffList: [],
      // 控制步骤按钮
      nextDisabled: false
    };
  },
  created: function created() {
    this.inif();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.activeData.state === 2) {
      this.$message({
        message: this.$t('payroll_salary_30'),
        type: 'warning'
      });
    }
    next();
  },
  methods: {
    inif: function inif() {
      this.activeObj = this.tabPaneArr[this.activeStep];
      this.loadSubProjectInfo(); // 获取子项目信息
      this.startTraining(true); // 当前数据状态
    },
    // 步骤条禁用
    handleDisabled: function handleDisabled(bool) {
      this.nextDisabled = bool;
    },
    loadSubProjectInfo: function loadSubProjectInfo() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, subProjectInfo;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return payrollSubProjectInfo({
                sub_project_id: _this.projectId
              });
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                subProjectInfo = res.data;
                _this.$set(subProjectInfo, 'date', [res.data.start_date, res.data.end_date]);
                _this.$set(subProjectInfo, 'att_date', [res.data.att_start_date, res.data.att_end_date]);
                _this.activeData.info = subProjectInfo;
                if (subProjectInfo.sub_project_status === '3') {
                  _this.activeStep = 2;
                  _this.activeObj = _this.tabPaneArr[_this.activeStep];
                }
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerBack: function handlerBack() {
      // 返回上一层
      this.$router.push({
        path: '/payroll/wage',
        query: {
          name: this.$route.query.name
        }
      });
    },
    changeList: function changeList(val) {
      if (val && val.length) this.subStaffList = val;
    },
    prev: function prev() {
      // 上一步
      this.activeStep--;
      this.activeObj = this.tabPaneArr[this.activeStep];
    },
    next: function next() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var calculateState, state, is_self_task;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!(_this2.activeStep === 1)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 4;
              return calculate({
                sub_project_id: _this2.projectId
              });
            case 4:
              _context2.next = 6;
              return getSubProjectCalculateState({
                sub_id: _this2.projectId
              });
            case 6:
              calculateState = _context2.sent;
              if (calculateState && calculateState.code === 1) {
                // state 4(计算失败) state 为3(计算完成) 或 state为2且is_self_task为1 跳转step3
                state = Number(calculateState.data.state);
                is_self_task = Number(calculateState.data.is_self_task);
                _this2.activeData.is_self_task = is_self_task;
                _this2.activeData.state = state;
                if ([3, 4].includes(state) || state === 2 && is_self_task === 1) {
                  // 为2 一直循环状态接口
                  if (state === 2) {
                    // 点击计算如果有page 需清空，否则会跳转道核对算薪人员
                    if (_this2.$route.query.page) _this2.$router.push({
                      query: _objectSpread(_objectSpread({}, _this2.$route.query), {}, {
                        page: ''
                      })
                    });
                    _this2.startTraining(true);
                  }
                  _this2.activeStep++;
                  _this2.activeObj = _this2.tabPaneArr[_this2.activeStep];
                } else {
                  // 不是本人操作返回列表页
                  _this2.$router.push({
                    path: '/payroll/wage',
                    query: {
                      name: _this2.$route.query.name
                    }
                  });
                }
              }
              _context2.next = 12;
              break;
            case 10:
              _this2.activeStep++;
              _this2.activeObj = _this2.tabPaneArr[_this2.activeStep];
            case 12:
              _context2.next = 16;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](0);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    },
    handleArchive: function handleArchive() {
      var _this3 = this;
      var str = '<div>';
      getOnFileNotice({
        sub_project_id: this.projectId
      }).then(function (res) {
        if (res.data.is_show_notice) {
          str += "\n      <p>".concat(_this3.$t('payroll_wage_50'), "</p>\n      ");
        } else {
          str += "<p>".concat(_this3.$t('payroll_wage_49'), "</p>");
        }
        str += '</div>';
        // 进行中 归档
        _this3.$confirm(str, _this3.$t('229'), {
          confirmButtonText: _this3.$t('1031'),
          cancelButtonText: _this3.$t('66'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(function () {
          payrollSubProjectOnFile({
            sub_project_id: _this3.projectId
          }).then(function (res) {
            _this3.$router.push("/payroll/wage?name=".concat(_this3.$route.query.name, "&pid=").concat(_this3.projectId));
          });
        });
      });
    },
    computedPayroll: function computedPayroll() {
      var params = {
        relation_type: 3,
        relation_id: this.projectId
      };
      var data = {
        sub_project_id: this.projectId
      };
      this.$refs.ExportExcelDialog.init(params, data);
      // 下载工资条
      // this.downloading = true
      // downloadPaySheet({ sub_project_id: this.projectId })
      //   .then(res => {
      //     if (res && res.code === 1) {
      //       this.$message({
      //         message: this.$t('payroll_salary_30'),
      //         type: 'success'
      //       })
      //     }
      //   })
      //   .finally(() => (this.downloading = false))
    },
    goToDetail: function goToDetail(state) {
      // 发放工资条
      this.$router.push({
        path: '/payroll/paywages-pay-slip/' + this.activeData.info.sub_project_id,
        query: {
          state: state,
          type: this.activeData.info.settlement_type,
          tax_deduction_status: this.activeData.info.tax_deduction_status
        }
      });
    },
    startTraining: function startTraining(type) {
      // 开始轮训
      if (!type) {
        // 为false 关闭定时器
        clearTimeout(this.clearTime);
        return;
      }
      var this_ = this;
      function timerFn() {
        return _timerFn.apply(this, arguments);
      }
      function _timerFn() {
        _timerFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var res;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSubProjectCalculateState({
                  sub_id: this_.projectId
                });
              case 2:
                res = _context3.sent;
                if (res && res.code === 1) {
                  this_.activeData.state = Number(res.data.state);
                  this_.activeData.is_self_task = Number(res.data.is_self_task);
                }
                // state: 3子项目为计算完成
                if ([3, 4].includes(this_.activeData.state)) {
                  this_.loadSubProjectInfo();
                  // 有page需跳转对应页面，没有则跳转第二个页面
                  this_.activeStep = this_.$route.query.page ? Number(this_.$route.query.page) : 2;
                  this_.activeObj = this_.tabPaneArr[this_.activeStep];
                }
                // state: 2子项目为计算中状态
                if (this_.activeData.state === 2) {
                  // is_self_task: 1是本人操作、停留在该页面接口一直请求 直到状态改为3，计算成功
                  if (this_.activeData.is_self_task === 1) {
                    this_.activeStep = 2;
                    this_.activeObj = this_.tabPaneArr[this_.activeStep];
                    this_.clearTime = setTimeout(timerFn, 5000);
                  } else {
                    // 不是本人操作返回列表页
                    this_.$router.push('/payroll/wage');
                  }
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return _timerFn.apply(this, arguments);
      }
      timerFn();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 停止轮训
    this.startTraining(false);
  }
};